import { render } from "./QuestionnaireHeader.vue?vue&type=template&id=e4899828&scoped=true"
import script from "./QuestionnaireHeader.vue?vue&type=script&lang=js"
export * from "./QuestionnaireHeader.vue?vue&type=script&lang=js"

import "./QuestionnaireHeader.vue?vue&type=style&index=0&id=e4899828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4899828"]])

export default __exports__